/**
 * Stripe.js loader for in-site (embedded) checkout.
 *
 * Guarded by REACT_APP_STRIPE_PUBLISHABLE_KEY: when it isn't set, embedded
 * checkout stays OFF and the payment components fall back to the existing
 * hosted-redirect flow — so this is safe to ship before the key is configured.
 */
import { loadStripe, Stripe } from '@stripe/stripe-js';

const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

/** True when in-site embedded checkout is available (publishable key present). */
export const embeddedCheckoutEnabled = !!PUBLISHABLE_KEY;

let stripePromise: Promise<Stripe | null> | null = null;

/** Lazily-initialised Stripe instance; null when no key is configured. */
export function getStripe(): Promise<Stripe | null> | null {
  if (!PUBLISHABLE_KEY) return null;
  if (!stripePromise) stripePromise = loadStripe(PUBLISHABLE_KEY);
  return stripePromise;
}
